import { toast } from "react-toastify";
import { Code2 } from "lucide-react";
import { PageHeader } from "@/components/admin/cards";
import { getSetting } from "../../../settings";

const ScriptComponent = ({ propertyId, hasWidgetKey }: any) => {
    const chatbotBaseUrl = getSetting("chatbotBaseUrl");

    const secureEmbedCode = `<script src="${chatbotBaseUrl}/hotel-chatbot.iife.js?hotelId=${encodeURIComponent(propertyId)}&widgetKey=YOUR_WIDGET_KEY"></script>`;

    const copyToClipboard = (code, label) => {
        navigator.clipboard.writeText(code).then(() => {
            toast.success(`${label} copied to clipboard!`);
        });
    };

    return (
        <>
            <PageHeader id="chatbotScriptHeading" icon={<Code2 />} title="Chatbot Script" className="mb-3"
                description="The code that puts the chatbot on your website." />

            {hasWidgetKey ? (
                <div className="mb-4">
                    <p className="text-muted mb-2" style={{ fontSize: "13px" }}>
                        Use this script to embed the chatbot on your website. Only the script tag is required — no additional div or link tags are needed.
                        Paste this code just before the closing <code>&lt;/body&gt;</code> tag on every page where you want the chatbot to appear.
                    </p>
                    <pre
                        style={{
                            background: "#f0f7f0",
                            padding: "1rem",
                            borderRadius: "5px",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            border: "1px solid #c3e6cb",
                        }}
                    >
                        <code>{secureEmbedCode}</code>
                    </pre>
                    <div className="text-end">
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm mt-1"
                            onClick={() => copyToClipboard(secureEmbedCode, "Embed code")}
                        >
                            <i className="bi bi-copy me-1"></i> Copy Code
                        </button>
                    </div>
                    <div className="alert alert-warning mt-3" role="alert" style={{ fontSize: "13px" }}>
                        <i className="bi bi-exclamation-triangle me-2"></i>
                        <strong>Important:</strong> Replace <code>YOUR_WIDGET_KEY</code> in the code above with the widget key you received when it was first generated.
                        If you've lost your key, go to <strong>Property Information &gt; Widget Security</strong> and click <strong>Regenerate Key</strong> to get a new one.
                    </div>
                    <div className="alert alert-info mt-2 mb-0" role="alert" style={{ fontSize: "13px" }}>
                        <i className="bi bi-globe me-2"></i>
                        <strong>Allowed Domains:</strong> Make sure the website domain where you paste this code is added to the <strong>Allowed Domains</strong> list
                        in <strong>Property Information &gt; Widget Security</strong>. The chatbot will only load on approved domains.
                    </div>
                </div>
            ) : (
                <div className="mb-4">
                    <div className="alert alert-secondary" role="alert" style={{ fontSize: "13px" }}>
                        <i className="bi bi-info-circle me-2"></i>
                        A widget key will be automatically generated when you save your property information for the first time.
                        Once generated, the embed code with instructions will appear here.
                    </div>
                </div>
            )}
        </>
    );
};

export default ScriptComponent;
